<app-side-nav></app-side-nav>

<mat-toolbar class="d-flex" [ngClass]="{'transparent-mode': transparentMode}">
  <app-main-header-menu [transparentMode]="transparentMode"></app-main-header-menu>
  <app-mobile-header></app-mobile-header>

</mat-toolbar>

<div class="main-content-container" [ngClass]="{'side-nav-open': isSidebarOpen}">
  <router-outlet></router-outlet>

  <main [@routerTransition]="o.isActivated ? o.activatedRoute : ''">
    <router-outlet #o="outlet"></router-outlet>
  </main>

</div>
